import {
  RuleFlowStatus,
  RuleFlowValidationStatus,
} from 'app/modules/ruleFlows/models';
import { U21Chip, U21ChipColor } from 'app/shared/u21-ui/components';

export const FLOW_STATUS_LABELS: Record<RuleFlowStatus, string> = {
  [RuleFlowStatus.ACTIVE]: 'Live',
  [RuleFlowStatus.ARCHIVED]: 'Archived',
  [RuleFlowStatus.DRAFT]: 'Draft',
  [RuleFlowStatus.VALIDATION]: 'Validation',
};

const FLOW_STATUS_CHIP_COLOR: Record<RuleFlowStatus, U21ChipColor> = {
  [RuleFlowStatus.ACTIVE]: 'success',
  [RuleFlowStatus.ARCHIVED]: 'error',
  [RuleFlowStatus.DRAFT]: 'default',
  [RuleFlowStatus.VALIDATION]: 'info',
};

export const VALIDATION_STATUS_LABELS: Record<
  RuleFlowValidationStatus,
  string
> = {
  [RuleFlowValidationStatus.COMPLETE]: 'Complete',
  [RuleFlowValidationStatus.FAILED]: 'Failed',
  [RuleFlowValidationStatus.PENDING]: 'Pending',
  [RuleFlowValidationStatus.RUNNING]: 'Running',
};

const VALIDATION_STATUS_CHIP_COLOR: Record<
  RuleFlowValidationStatus,
  U21ChipColor
> = {
  [RuleFlowValidationStatus.COMPLETE]: 'success',
  [RuleFlowValidationStatus.FAILED]: 'error',
  [RuleFlowValidationStatus.PENDING]: 'default',
  [RuleFlowValidationStatus.RUNNING]: 'info',
};

const isValidationStatus = (
  s: RuleFlowStatus | RuleFlowValidationStatus,
): s is RuleFlowValidationStatus => s in VALIDATION_STATUS_LABELS;

export interface FlowStatusChipProps {
  status?: RuleFlowStatus | RuleFlowValidationStatus;
}

export const FlowStatusChip = ({ status }: FlowStatusChipProps) => {
  if (status === undefined) {
    return null;
  }
  const color = isValidationStatus(status)
    ? VALIDATION_STATUS_CHIP_COLOR[status]
    : FLOW_STATUS_CHIP_COLOR[status];
  const label = isValidationStatus(status)
    ? VALIDATION_STATUS_LABELS[status]
    : FLOW_STATUS_LABELS[status];
  return <U21Chip color={color}>{label}</U21Chip>;
};
